import { fetcher } from '@shared/fetcher';
import { IUser } from '@shared/types.ts';

export async function fetchProfile(url: string) {
  return fetcher.get<{ data: IUser }>(url);
}

export async function updateProfile(
  url: string,
  data: {
    arg: {
      first_name: string;
      last_name: string;
      address: string;
      fcm_token: string;
    };
  }
) {
  return fetcher.post<{ data: IUser }>(url, data);
}
